import { getTransportActualCosts, getTransportCosts, getTransportVendors } from "@/repositories/kintoneConvertor";

export default {
  async fetchTransportVendorsFromJC() {
    return await getTransportVendors();
  },
  async getActualCostsFromJC(auctionSiteId: number,satelliteId:number , area: string, fromYardPlace: number,placeYardType:string): Promise<any> {
    return await getTransportActualCosts({
      auctionSiteId: auctionSiteId,
      satelliteId:satelliteId,
      yardArea: area,
      orderBy: 'Actual_Cost asc',
      fromYardPlace: fromYardPlace,
      placeYardType: placeYardType

    });
  },
  async getCostsFromJC(auctionSiteId: number,satelliteId:number , area: string, customerId: string,fromYardPlace: number, placeYardType:string): Promise<any> {
    return await  getTransportCosts({
      auctionSiteId: auctionSiteId,
      satelliteId:satelliteId,
      yardArea: area,
      customerId: customerId,
      fromYardPlace: fromYardPlace,
      placeYardType: placeYardType
    })
  },
};
